import { useSelector } from 'react-redux';
import { LargePurchaseData } from './LargePurchase.meta';
import { AT_RETIREMENT } from '../../Goals.meta';
import { selectCurrentClient } from '../../../../CommonSelectors/CommonAreaSelector';

interface Params {
  goalData: LargePurchaseData;
  yearsOptions: number[];
}

export const useLargePurchase = ({ goalData, yearsOptions }: Params) => {
  const { Dob: primaryDob, PartnerDob: spouseDob } = useSelector(selectCurrentClient);

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;

  return {
    ...goalData,
    purchaseYearsOptions: [
      { value: AT_RETIREMENT, label: AT_RETIREMENT },
      ...yearsOptions.map(year => ({
        label: year.toString(),
        value: year,
        rightLabel: primaryYob
          ? `Age ${year - primaryYob}${spouseYob ? `, Age ${year - spouseYob}` : ''}`
          : undefined,
      })),
    ],
  };
};
